/** EarningsIntelligenceRoute — skin-aware switcher for /earnings-intelligence. */
import { useUISkin } from "@/data/UISkinContext";
import EarningsIntelligence from "./EarningsIntelligence";
import EarningsIntelligenceCockpit from "./EarningsIntelligenceCockpit";

export default function EarningsIntelligenceRoute() {
  const { skin } = useUISkin();
  if (skin === "cockpit") return <EarningsIntelligenceCockpit />;
  return <EarningsIntelligence />;
}
